import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

function Loader({ progressOnly = false }: { progressOnly?: boolean }): React.JSX.Element {
	if (progressOnly) {
		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					height: '100%',
					paddingBlock: '20%',
				}}
			>
				<CircularProgress />
			</Box>
		)
	}
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				height: '100%',
				paddingBlock: '20%',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<Typography
					variant='body2'
					sx={{ color: 'var(--primary-dark)', fontFamily: 'var(--font-family)' }}
				>
					A carregar dados, aguarde por favor
				</Typography>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						marginBlockStart: '1rem',
					}}
				>
					<CircularProgress />
				</Box>
			</Box>
		</Box>
	)
}

export default Loader
